module.exports = now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/date-now/index.js
// module id = 506
// module chunks = 17